<template>
  <div class="flex w-fit max-w-full flex-wrap gap-1 rounded-lg bg-gray-100 p-1" role="group" aria-label="Show">
    <button
      v-for="item in items"
      :key="item.tab"
      type="button"
      class="inline-flex h-8 items-center gap-1.5 rounded px-3 text-sm font-semibold transition-colors duration-150 ease-out"
      :class="item.tab === tab ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'"
      :aria-pressed="item.tab === tab"
      @click="emit('select', item.tab)"
    >
      {{ item.label }}
      <span v-if="counts" class="font-medium tabular-nums" :class="item.tab === PO_TRACKER_TAB.LATE && counts[item.tab] > 0 ? 'text-red-700' : ''">{{ counts[item.tab] }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import { PO_TRACKER_TAB, type PoTrackerTab } from '@/types/poTracker';

  const props = defineProps<{ tab: PoTrackerTab; counts: Record<PoTrackerTab, number> | null; showUpdated: boolean }>();
  const emit = defineEmits<{ select: [tab: PoTrackerTab] }>();

  const items = computed(() => [
    { tab: PO_TRACKER_TAB.ALL, label: 'All' },
    ...(props.showUpdated ? [{ tab: PO_TRACKER_TAB.UPDATED, label: 'Updated' }] : []),
    { tab: PO_TRACKER_TAB.LATE, label: 'Late' },
    { tab: PO_TRACKER_TAB.THIS_WEEK, label: 'This week' },
    { tab: PO_TRACKER_TAB.PARTLY_PLANNED, label: 'Partly planned' },
    { tab: PO_TRACKER_TAB.NO_DATE, label: 'No date' },
  ]);
</script>
